import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TextArea from '../TextArea';

class InputTextArea extends Component {
  render() {
    const {
      name,
      maxLength,
      onChange,
      onFocus,
      onBlur,
      value,
      error,
      className,
    } = this.props;
    return (
      <TextArea
        className={className}
        maxLength={maxLength}
        hasvalue={Boolean(value).toString()}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        error={error}
      />
    );
  }
}

InputTextArea.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  maxLength: PropTypes.number,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

export default InputTextArea;